import { render, staticRenderFns } from "./CustomEvent.vue?vue&type=template&id=4b7e7ad8"
import script from "./CustomEvent.vue?vue&type=script&lang=ts"
export * from "./CustomEvent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports